import { SurveyTemplateEditPageStep } from "@/pages/talent/surveys/templates/edit/survey-template-edit.ts";
import { ApiFormTemplate } from "@/types/forms/form-template.types.ts";
import { DotSeparator, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

const surveyTemplateSteps = [
  SurveyTemplateEditPageStep.details,
  SurveyTemplateEditPageStep.questions,
];

interface SurveyTemplateTitleSlotProps {
  step: SurveyTemplateEditPageStep;
  template?: ApiFormTemplate;
}

export const SurveyTemplateTitleSlot = ({ step, template }: SurveyTemplateTitleSlotProps) => {
  const { t } = useTranslation();
  const stepIndex = surveyTemplateSteps.indexOf(step);

  return (
    <DotSeparator className={"inline-flex"}>
      <Text className={"font-semibold"}>{t("surveys:survey_template")}</Text>
      {stepIndex > 0 && template && (
        <Stack gap={"sm"} direction={"horizontal"} items={"center"}>
          <Text className={"font-semibold"}>{template.title}</Text>
        </Stack>
      )}
      <Text>
        {t("core:step_of", {
          currentStep: stepIndex + 1,
          countSteps: surveyTemplateSteps.length,
        })}
      </Text>
    </DotSeparator>
  );
};
